import { PROFILER_INDUSTRY_CODES_SEARCH_FIELDS } from '../../../../utils/constants/fields';
import RangeInput from '../../../../components/inputs/RangeInput';
import MultiSelect from '../../../../components/inputs/MultiSelect';
import OwnershipInfoButton from '../../../../components/profiler/ownership/OwnershipInfoButton';
import {
  isProfilerAdvancedCriteriaDisabled,
  isProfilerAdvancedCriteriaOwnershipDisabled
} from '../../../../utils/constants/variables';
import Input from '../../../../components/inputs/Input';
import CityZipAutocompleteInput from '../../../../components/inputs/CityZipAutocompleteInput';
import { PROFILER_INDUSTRY_CODES_SEARCH_CATEGORIES } from '../../../../utils/constants/searchCategories';

export const getProfilerIndustryCodesSearchFields = (state) => {
  // const disableInputsByLoader = state.isLoading || state.isInitialLoading;
  const disableInputsByDemoExceedLimit = state.isProfilerIndustryCodesSearchFieldsDisabled;

  // The ownership chain position is required, and only enabled, with a structure.
  const hasOwnershipStructure = !!state.profilerIndustryCodesFields[
    PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.OWNERSHIP_STRUCTURES.NAME
  ]?.length;

  return {
    [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.REVENUE_MIN.ID +
    PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.REVENUE_MAX.ID]: (
      <RangeInput
        fieldMin={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.REVENUE_MIN}
        fieldMax={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.REVENUE_MAX}
        valueMin={
          state.profilerIndustryCodesFields[PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.REVENUE_MIN.NAME]
        }
        valueMax={
          state.profilerIndustryCodesFields[PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.REVENUE_MAX.NAME]
        }
        setFieldValue={state.setProfilerIndustryCodesFieldValue}
        // disabled={disableInputsByLoader || disableInputsByDemoExceedLimit}
        disabled={disableInputsByDemoExceedLimit}
        messages={state.profilerIndustryCodesValidationFields.messages}
        showOnSubmitErrorState={state.onProfilerIndustryCodesSubmitErrorState}
        wrapClass={'col'}
      />
    ),
    [PROFILER_INDUSTRY_CODES_SEARCH_CATEGORIES.ADVANCED_SEARCH_CRITERIA]: {
      [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_MIN.ID +
      PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_MAX.ID]: (
        <RangeInput
          fieldMin={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_MIN}
          fieldMax={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_MAX}
          valueMin={
            state.profilerIndustryCodesFields[PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_MIN.NAME]
          }
          valueMax={
            state.profilerIndustryCodesFields[PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_MAX.NAME]
          }
          setFieldValue={state.setProfilerIndustryCodesFieldValue}
          // disabled={disableInputsByLoader || disableInputsByDemoExceedLimit}
          disabled={disableInputsByDemoExceedLimit}
          messages={state.profilerIndustryCodesValidationFields.messages}
          showOnSubmitErrorState={state.onProfilerIndustryCodesSubmitErrorState}
          wrapClass={'col'}
        />
      ),
      [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_PERIOD.ID]: (
        <MultiSelect
          field={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_PERIOD}
          value={
            state.profilerIndustryCodesFields[
              PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_PERIOD.NAME
            ]
          }
          setFieldValue={state.setProfilerIndustryCodesFieldValue}
          // disabled={disableInputsByLoader || disableInputsByDemoExceedLimit}
          inputWrap={{ enable: true, className: 'col' }}
          withSingleClear
          forceRequired={
            !!state.profilerIndustryCodesFields[
              PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_MIN.NAME
            ] ||
            !!state.profilerIndustryCodesFields[PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_MAX.NAME]
          }
          disabled={
            disableInputsByDemoExceedLimit ||
            (!state.profilerIndustryCodesFields[
              PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_MIN.NAME
            ] &&
              !state.profilerIndustryCodesFields[
                PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CAGR_MAX.NAME
              ])
          }
        />
      ),
      // Profiler Lite has no EBIT-margin data (withheld server-side), so the
      // EBIT-margin range is dropped from the "Adjust search" criteria. CAGR stays.
      ...(state.isProfilerLiteOnly
        ? {}
        : {
            [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EBIT_MARGIN_MIN.ID +
            PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EBIT_MARGIN_MAX.ID]: (
              <RangeInput
                fieldMin={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EBIT_MARGIN_MIN}
                fieldMax={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EBIT_MARGIN_MAX}
                valueMin={
                  state.profilerIndustryCodesFields[
                    PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EBIT_MARGIN_MIN.NAME
                  ]
                }
                valueMax={
                  state.profilerIndustryCodesFields[
                    PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EBIT_MARGIN_MAX.NAME
                  ]
                }
                setFieldValue={state.setProfilerIndustryCodesFieldValue}
                disabled={disableInputsByDemoExceedLimit}
                messages={state.profilerIndustryCodesValidationFields.messages}
                showOnSubmitErrorState={state.onProfilerIndustryCodesSubmitErrorState}
                wrapClass={'col'}
              />
            )
          }),
      [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EMPLOYEES_MIN.ID +
      PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EMPLOYEES_MAX.ID]: (
        <RangeInput
          fieldMin={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EMPLOYEES_MIN}
          fieldMax={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EMPLOYEES_MAX}
          valueMin={
            state.profilerIndustryCodesFields[
              PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EMPLOYEES_MIN.NAME
            ]
          }
          valueMax={
            state.profilerIndustryCodesFields[
              PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.EMPLOYEES_MAX.NAME
            ]
          }
          setFieldValue={state.setProfilerIndustryCodesFieldValue}
          // disabled={disableInputsByLoader || disableInputsByDemoExceedLimit}
          disabled={disableInputsByDemoExceedLimit}
          messages={state.profilerIndustryCodesValidationFields.messages}
          showOnSubmitErrorState={state.onProfilerIndustryCodesSubmitErrorState}
          wrapClass={'col'}
        />
      ),
      [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.SITUATION.ID]: (
        <MultiSelect
          field={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.SITUATION}
          value={
            state.profilerIndustryCodesFields[PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.SITUATION.NAME]
          }
          setFieldValue={state.setProfilerIndustryCodesFieldValue}
          // disabled={disableInputsByLoader || disableInputsByDemoExceedLimit}
          disabled={disableInputsByDemoExceedLimit}
          inputWrap={{ enable: true, className: 'col' }}
        />
      ),
      [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.LISTING_STATUS.ID]:
        isProfilerAdvancedCriteriaDisabled || isProfilerAdvancedCriteriaOwnershipDisabled ? null : (
          <MultiSelect
            field={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.LISTING_STATUS}
            labelAddon={<OwnershipInfoButton />}
            value={
              state.profilerIndustryCodesFields[
                PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.LISTING_STATUS.NAME
              ]
            }
            setFieldValue={state.setProfilerIndustryCodesFieldValue}
            disabled={disableInputsByDemoExceedLimit}
            inputWrap={{ enable: true, className: 'col' }}
          />
        ),
      [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.OWNERSHIP_STRUCTURES.ID]:
        isProfilerAdvancedCriteriaDisabled || isProfilerAdvancedCriteriaOwnershipDisabled ? null : (
          <MultiSelect
            field={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.OWNERSHIP_STRUCTURES}
            value={
              state.profilerIndustryCodesFields[
                PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.OWNERSHIP_STRUCTURES.NAME
              ]
            }
            setFieldValue={state.setProfilerIndustryCodesFieldValue}
            disabled={disableInputsByDemoExceedLimit}
            inputWrap={{ enable: true, className: 'col' }}
          />
        ),
      // Like CAGR period: disabled until a structure is chosen, then required.
      [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.OWNERSHIP_BASIS.ID]:
        isProfilerAdvancedCriteriaDisabled || isProfilerAdvancedCriteriaOwnershipDisabled ? null : (
          <MultiSelect
            field={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.OWNERSHIP_BASIS}
            value={
              state.profilerIndustryCodesFields[
                PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.OWNERSHIP_BASIS.NAME
              ]
            }
            setFieldValue={state.setProfilerIndustryCodesFieldValue}
            withSingleClear
            inputWrap={{ enable: true, className: 'col' }}
            forceRequired={hasOwnershipStructure}
            disabled={disableInputsByDemoExceedLimit || !hasOwnershipStructure}
          />
        ),
      [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.HEADQUARTER.ID]: (
        <MultiSelect
          field={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.HEADQUARTER}
          value={
            state.profilerIndustryCodesFields[
              PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.HEADQUARTER.NAME
            ]
          }
          setFieldValue={state.setProfilerIndustryCodesFieldValue}
          // disabled={disableInputsByLoader || disableInputsByDemoExceedLimit}
          disabled={disableInputsByDemoExceedLimit}
          inputWrap={{ enable: true, className: 'col' }}
          withSingleClear
        />
      ),
      [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CITY_ZIPCODE.ID]: (
        <CityZipAutocompleteInput
          field={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CITY_ZIPCODE}
          value={
            state.profilerIndustryCodesFields[
              PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CITY_ZIPCODE.NAME
            ]
          }
          setFieldValue={state.setProfilerIndustryCodesFieldValue}
          countries={
            state.profilerIndustryCodesFields[
              PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.HEADQUARTER.NAME
            ]
          }
          messages={state.profilerIndustryCodesValidationFields.messages}
          showOnSubmitErrorState={state.onProfilerIndustryCodesSubmitErrorState}
          inputWrap={{ enable: true, className: 'col' }}
          disabled={
            disableInputsByDemoExceedLimit ||
            !(
              state.profilerIndustryCodesFields[
                PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.HEADQUARTER.NAME
              ]?.length > 0
            )
          }
        />
      ),
      [PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.DISTANCE.ID]: (
        <Input
          field={PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.DISTANCE}
          value={
            state.profilerIndustryCodesFields[PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.DISTANCE.NAME]
          }
          setFieldValue={state.setProfilerIndustryCodesFieldValue}
          // disabled={disableInputsByLoader || disableInputsByDemoExceedLimit}
          disabled={
            disableInputsByDemoExceedLimit ||
            !state.profilerIndustryCodesFields[
              PROFILER_INDUSTRY_CODES_SEARCH_FIELDS.CITY_ZIPCODE.NAME
            ]?.trim()
          }
          messages={state.profilerIndustryCodesValidationFields.messages}
          showOnSubmitErrorState={state.onProfilerIndustryCodesSubmitErrorState}
          inputWrap={{ enable: true, className: 'col' }}
        />
      )
    }
  };
};
